import iHeartMessage from "../../../../assets/icons/heart-message.svg";
import "./timeline-block-title.sass";

const AboutUsTimelineBlockTitle = () => {
  return (
    <div className="timeline-block-title">
      <div className="timeline-block-title__title">
        Мы команда креативных
        <br />
        экспертов с опытом более 15 лет
        <img src={iHeartMessage} className="timeline-block-title__img" alt="" />
      </div>

      <div className="timeline-block-title__text">
        Начинали с промо персонала на различные проекты, а сегодня создаем
        мощные коммуникационные решения
      </div>
    </div>
  );
};

export default AboutUsTimelineBlockTitle;
